
/**
 * Custom component for Bimini food items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.0
 * @copyright  Copyright (C) 2023, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-06-07 (1.0.0) (jhoward)
 *      - <panchoWilliesFoodItem> copied to <pancho-willies-cervezas-item>.
 */

import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import PanchoWilliesFoodItem from "./PanchoWillies_foodItem.vue";

export default defineComponent({
  name: 'pancho-willies-cervezas-item',
  components: {
    PanchoWilliesFoodItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
    pricingTypes: {
      type: Array as PropType<string[]>,
      default: () => []
    }
  },
})
